import React from "react";
import { withStyles } from "@material-ui/core/styles";
import LightTooltip from "../LightTooltip";
import styles from "./styles";

const LongText = (props) => {
  const { classes, text = "", width = "180px", placement = "bottom" } = props;

  return (
    <LightTooltip title={text ? text : ""} placement={placement}>
      <p className={classes.overflowEllipsis} style={{ width: width }}>
        {text}
      </p>
    </LightTooltip>
  );
}

export default withStyles(styles, { withTheme: true })(LongText);